import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faPen, faPercent, faPlus, faVial, faWarning } from '@fortawesome/free-solid-svg-icons'
import { Empty, Tooltip } from 'antd'
import { TypeInsetAtivos } from '../..'
import { ItensPerUserLogged } from '../../../../../../../../services/login/permissaoUsuarioLoado'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import Input from '../../../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../../../Components/ButtonCustom'
import { HeaderTable } from '../../../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../../../../Components/CustomUi/loading'

interface PropsFormComposicao {
  dataAtivos: any[]
  ativo: string
  setAtivo: React.Dispatch<React.SetStateAction<string>>
  ativosId: number
  setAtivoId: React.Dispatch<React.SetStateAction<number>>
  concentracao: string
  setConcentracao: React.Dispatch<React.SetStateAction<string>>
  adicionarAtivos: Function
  ativos: TypeInsetAtivos[]
  salvarAtivo: Function
  editarAtivo: Function
  mudarConcentracao: Function
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<string | number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  handleRemoveAtivo: Function
  permissions: ItensPerUserLogged;
  classe_agronimica_principal: number,
  carregando_remover_ativo: boolean
}

export const FormComposicao: React.FC<PropsFormComposicao> = ({
  dataAtivos,
  ativo,
  setAtivo,
  ativosId,
  setAtivoId,
  concentracao,
  setConcentracao,
  adicionarAtivos,
  ativos,
  salvarAtivo,
  editarAtivo,
  mudarConcentracao,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  handleRemoveAtivo,
  permissions,
  classe_agronimica_principal,
  carregando_remover_ativo
}) => {
  const [openAtivo, setOpenAtivo] = useState(false)
  const handleChangeMask = (data) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')
    setConcentracao(area)
  }

  return (
    <div style={{ display: 'flex', gap: 10, flexDirection: 'column' }}>
      <div className='campo__dois__inputs'>
        <Select
          label='Ativos'
          placeholder='Selecione o ativo'
          icon={faVial}
          value={ativo}
          onChange={setAtivo}
          onChangeID={setAtivoId}
          open={openAtivo}
          trigger={setOpenAtivo}
          items={dataAtivos}
          descricaoItem={'nome'}
          idItem={'cod'}
          disabled={dataAtivos.length <= 0 || permissions?.acesso === 1}
        />
        <Input
          label='Concentração'
          icon={faPercent}
          placeholder={'0,00'}
          width={200}
          value={concentracao}
          onChange={handleChangeMask}
          desabilitado={permissions?.acesso === 1}
        />
        <div style={{ height: '55px', display: 'flex', alignItems: 'flex-end' }}>
          <ButtonCustom
            isCircle
            onClick={adicionarAtivos}
            icon={<FontAwesomeIcon icon={faPlus} />}
            disabled={permissions?.acesso === 1}
          />
        </div>
      </div>
      <HeaderTable
        itens={[
          { valor: 'Ativo', width: 'calc(100% - 280px)' },
          { valor: 'Concentração', width: '160px' },
          { valor: 'Ações', width: '120px' },
        ]}
      />

      <BodyTable
        style={{
          height: 'calc(100vh - 350px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={true}>
          {(ativos ?? []).map(({ cod, cod_ativo, uid, nomeAtivo, concentracao, editable, ativo }) => {
            let cod_cl_agro_ativo = Number(ativo?.[0]?.cod_classe_agronomica)
            return (
              <RowTable key={cod} onDoubleClick={() => { }}>
                <RowItem fontSize={13} width={'calc(100% - 275px)'} gap={10}>
                  {(cod_cl_agro_ativo !== classe_agronimica_principal && !isNaN(cod_cl_agro_ativo)) && (
                    <Tooltip title='O ativo desta composição possui classe agronômica diferente da do insumo.'>
                      <FontAwesomeIcon icon={faWarning} color='orange' />
                    </Tooltip>
                  )}

                  {nomeAtivo}
                </RowItem>
                <RowItem fontSize={13} width={'160px'}>
                  {editable ? (
                    <Input
                      icon={faPercent}
                      placeholder={''}
                      value={String(concentracao)}
                      onChange={(v) => mudarConcentracao(v, uid)}
                      allowClear={false}
                      desabilitado={permissions?.acesso === 1}
                    />
                  ) : (
                    `${concentracao} %`
                  )}
                </RowItem>

                <RowItem width={'115px'} gap={10}>
                  <DeleteButton
                    open={confirmar_exclusao && id_item_atual === (uid ?? cod)}
                    trigger={setConfirmar_exclusao}
                    onTrigger={() => {
                      setId_item_atual(uid ?? cod)
                      setNome_item_atual(nomeAtivo)
                    }}
                    loading={carregando_remover_ativo}
                    message={`o item ${nomeAtivo} será excluido!`}
                    deleteds={[nomeAtivo]}
                    onDelete={() => handleRemoveAtivo(uid, cod_ativo, cod === null)}
                    disabled={carregando_remover_ativo || permissions?.acesso === 1}
                    //  disabledTrigger={permissao?.exclusao === 0}

                    typeButtonTrigger='secondary'
                  />
                  <ButtonCustom
                    onClick={() => (editable ? salvarAtivo(cod) : editarAtivo(uid))}
                    icon={<FontAwesomeIcon icon={editable ? faCheck : faPen} />}
                    disabled={cod === null || permissions?.acesso === 1}
                  />
                </RowItem>
              </RowTable>
            )
          })}
        </Render>

        <Render condition={(ativos ?? []).length === 0}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<> Nenhum registro disponível!</>}
          />
        </Render>

        <Render condition={false}>
          <Carregando
            animation
            legenda='Carregando análises...'
            justifyContent='center'
            height={'100%'}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}